<template>
  <div v-if="!loading">
    <b-row>
      <b-col v-for="(item, index) in statisticsItems" :key="index" md="6" lg="4">
        <b-card>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h4 v-if="index == 2" class="font-weight-bolder mb-0">
                {{ (Math.round(item.title / 10).toLocaleString('fa-IR')) }}
              </h4>
              <h4 v-else class="font-weight-bolder mb-0">
                {{ item.title.toLocaleString('fa-IR') }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                {{ item.subtitle }}
              </b-card-text>
            </div>
            <div>
              <b-avatar size="48" :variant="item.color">
                <feather-icon size="24" :icon="item.icon" />
              </b-avatar>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="2" class="mb-2">
        <b-form-input v-model="parameters.searchTerm" placeholder="شماره همراه یا شناسه مجموعه" />
      </b-col>
      <b-col md="2" class="mb-2">
        <v-select v-model="parameters.sortBy" dir="rtl" placeholder="نوع ترتیب نمایش" :options="sortByData"
          :reduce="(value) => value.id" label="name" class="bg-white" style="border-radius: 8px;" :clearable="false">
          <template #no-options>
            موردی وجود ندارد
          </template>
        </v-select>
      </b-col>
      <b-col md="2" class="mb-2">
        <v-select v-model="parameters.sortAscending" dir="rtl" placeholder="ترتیب نمایش" :options="sortAscendingData"
          :reduce="(value) => value.id" class="bg-white" style="border-radius: 8px;" label="name" :clearable="false">
          <template #no-options>
            موردی وجود ندارد
          </template>
        </v-select>
      </b-col>
      <b-col md="2" class="mb-2">
        <v-select v-model="parameters.subscriptionId" dir="rtl" placeholder="نوع اشتراک" :options="subscriptionIdData"
          :reduce="(value) => value.id" class="bg-white" style="border-radius: 8px;" label="name" :clearable="false">
          <template #no-options>
            موردی وجود ندارد
          </template>
        </v-select>
      </b-col>
      <b-col md="2" class="mb-2">
        <v-select v-model="parameters.isDeleted" dir="rtl" placeholder="وضعیت مجموعه" :options="isDeletedData"
          :reduce="(value) => value.id" class="bg-white" style="border-radius: 8px;" label="name" :clearable="false">
          <template #no-options>
            موردی وجود ندارد
          </template>
        </v-select>
      </b-col>
      <b-col md="2" class="mb-2">
        <b-button @click="getListStores" variant="primary" class="w-100">اعمال فیلتر</b-button>
      </b-col>
    </b-row>
    <b-card class="p-0" no-body>
      <b-overlay :show="loadingPage" variant="transparent" opacity="1" blur="3px" rounded="sm">
        <b-table responsive :items="listStores" :fields="fields" class="mb-0">
          <template #cell(registerDate)="data">
            {{ new Date(data.item.registerDate).toLocaleDateString('fa-IR') }}
          </template>
          <template #cell(hasReservedSubscription)="data">
            <feather-icon :icon="data.item.hasReservedSubscription ? 'CheckIcon' : 'XIcon'" size="18"
              :class="data.item.hasReservedSubscription ? 'text-success' : 'text-warning'" />
          </template>
          <template #cell(isDeleted)="data">
            <div :class="data.item.isDeleted ? 'text-warning' : ''">
              {{ data.item.isDeleted ? 'غیرفعال' : 'فعال' }}
            </div>
          </template>
          <template #cell(id)="data">
            <router-link :to="`/store?id=${data.item.id}`">
              <feather-icon icon="EyeIcon" size="18" class="text-info" />
            </router-link>
          </template>
        </b-table>
      </b-overlay>
    </b-card>
    <b-pagination align="center" @input="getListStores" v-model="parameters.pageIndex"
      :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />


  </div>
</template>

<script>
import { BCard, BCardText, BLink, BRow, BCol, BButton, BImg, BAvatar, BTable, BPagination, BOverlay, BFormInput } from 'bootstrap-vue';
import { adminService } from '@core/services';
import vSelect from 'vue-select';

export default {
  components: {
    BCard,
    BCardText,
    BLink,
    BRow,
    BCol,
    BButton,
    BImg,
    BAvatar,
    BTable,
    BPagination,
    BFormInput,
    BOverlay,
    vSelect
  },
  data() {
    return {
      loading: true,
      loadingPage: false,
      statisticsItems: [
        {
          icon: 'CpuIcon',
          color: 'light-secondary',
          title: '',
          subtitle: 'محتوای در انتظار بررسی',
        },
        {
          icon: 'CpuIcon',
          color: 'light-secondary',
          title: '',
          subtitle: 'تیکت های در انتظار بررسی',
        },
        {
          icon: 'DollarSignIcon',
          color: 'light-success',
          title: '',
          subtitle: 'فروش اشتراک (تومان)',
        },
        {
          icon: 'DollarSignIcon',
          color: 'light-success',
          title: '',
          subtitle: 'میانگین تمدید سالانه (تومان)',
        },
        {
          icon: 'ActivityIcon',
          color: 'light-primary',
          title: '',
          subtitle: 'بازدید از منوها',
        },
        {
          icon: 'HomeIcon',
          color: 'light-primary',
          title: '',
          subtitle: 'بازدید از لندینگ',
        },
      ],
      sortByData: [
        { name: 'تاریخ عضویت', id: 0 },
        { name: 'باقیمانده روزهای اشتراک', id: 1 },
      ],
      sortAscendingData: [
        { name: 'صعودی', id: true },
        { name: 'نزولی', id: false },
      ],
      subscriptionIdData: [
        { name: 'پایه', id: 1 },
        { name: 'پیشرفته', id: 2 },
        { name: 'رویال', id: 3 },
      ],
      isDeletedData: [
        { name: 'همه', id: null },
        { name: 'غیرفعال', id: true },
        { name: 'فعال', id: false },
      ],
      parameters: {
        pageIndex: 1,
        pageSize: 10,
        searchTerm: null,
        sortAscending: null,
        sortBy: null,
        subscriptionId: null,
        totalCount: null,
        isDeleted: false
      },
      fields: [
        {
          key: 'adminPhoneNumber',
          label: 'شماره همراه',
        },
        {
          key: 'name_En',
          label: 'شناسه مجموعه',
        },
        {
          key: 'name_Fa',
          label: 'نام مجموعه',
        },
        {
          key: 'registerDate',
          label: 'تاریخ عضویت',
        },
        {
          key: 'subscription.title',
          label: 'نوع اشتراک',
        },
        {
          key: 'subscription.remainingDays',
          label: 'باقیمانده روزهای اشتراک',
        },
        {
          key: 'hasReservedSubscription',
          label: 'رزرو اشتراک',
        },
        {
          key: 'isDeleted',
          label: 'وضعیت مجموعه',
        },
        {
          key: 'id',
          label: 'جزئیات',
        },
      ],
      listStores: [],
    };
  },
  methods: {
    getDashboard() {
      adminService.getDashboard().then(({ data }) => {
        let today = new Date().toLocaleDateString('fa-IR');
        this.statisticsItems[0].title = data.totalContentPendingReview ? data.totalContentPendingReview : 0
        this.statisticsItems[1].title = data.totalUnderReviewTickets
        this.statisticsItems[2].title = data.totalAmountOfTransactions
        this.statisticsItems[4].title = data.totalVisitsOfMenus
        this.statisticsItems[5].title = data.totalVisitsOfLanding
        this.getListStores()
      })
    },
    getListStores() {
      this.loadingPage = true
      adminService.getListStores(this.parameters).then(({ data }) => {
        this.parameters.totalCount = data.totalCount
        this.listStores = data.items
        const subscriptionPrices = {
          'رویال': 19000000,
          'پیشرفته': 13000000,
          'پایه': 6000000
        }
        let totalAnnualRevenue = 0
        this.listStores.forEach(store => {
          if (store.subscription && store.subscription.title) {
            const price = subscriptionPrices[store.subscription.title] || 0
            totalAnnualRevenue += price
          }
        })
        totalAnnualRevenue = totalAnnualRevenue - 19000000
        this.statisticsItems[3].title = totalAnnualRevenue
        this.loadingPage = false
        this.loading = false
      })
    },
  },
  mounted() {
    this.getDashboard()
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>